<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات مقاله"
        >
          <b-form
            ref="blogform"
            @submit.prevent
          >
            <b-row>
              <b-col
                class="mt-2 form-size"
                md="8"
              >
                <b-row>
                  <b-tabs>

                    <b-tab title="اطلاعات">
                      <b-row class="mt-2">

                        <b-col
                          class="image"
                          cols="12"
                        >
                          <b-media class="mb-2">
                            <template #aside>
                              <b-avatar
                                ref="previewEl"
                                :src="Form.Image"
                                size="90px"
                                rounded
                                button
                                @click="$refs.refInputEl.click()"
                              />
                            </template>
                            <input
                              :ref="'refInputEl'"
                              type="file"
                              class="d-none"
                              name="Image"
                              @input="imageRenderer($event)"
                            >
                            <b-row>
                              <b-col md="10">
                                <b-form-group
                                  label="عنوان"
                                  label-for="Title"
                                  class="mb-0"
                                >
                                  <b-form-input
                                    id="Title"
                                    v-model="Form.Title"
                                    name="Title"
                                    autocomplete="off"
                                  />
                                </b-form-group>
                              </b-col>
                              <b-col md="2">
                                <b-form-group
                                  label="ترتیب"
                                  label-for="Sort"
                                  class="mb-0"
                                >
                                  <b-form-input
                                    id="Sort"
                                    v-model="Form.Sort"
                                    name="Sort"
                                    autocomplete="off"
                                  />
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-media>
                        </b-col>

                        <b-col md="12">
                          <b-form-group
                            label="پیوند یکتا"
                            label-for="Slug"
                          >
                            <b-form-input
                              id="Sort"
                              v-model="Form.Slug"
                              name="Slug"
                              autocomplete="off"
                              dir="ltr"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="نوع"
                            label-for="Type"
                          >
                            <v-select
                              v-model="Form.Type"
                              :options="enums('BlogType')"
                              dir="rtl"
                              label="text"
                              :reduce="x => x.value"
                              :clearable="false"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="وضعیت"
                            label-for="Visibility"
                          >
                            <v-select
                              v-model="Form.Visibility"
                              :options="enums('IsActive')"
                              dir="rtl"
                              label="text"
                              name="Visibility"
                              :clearable="false"
                              :reduce="x => x.value"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group
                            label="دسته بندی"
                            label-for="BlogCategoryId"
                          >
                            <z-blog-category
                              v-model="Form.BlogCategoryId"
                              :multiple="false"
                              :clearable="false"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group
                            label="نویسنده"
                            label-for="Author"
                          >
                            <b-form-input
                              id="Author"
                              v-model="Form.Author"
                              name="Author"
                              autocomplete="off"
                            />
                          </b-form-group>

                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="تاریخ انتشار"
                            label-for="PublishAt"
                          >
                            <date-picker
                              v-model="Form.PublishAt"
                              placeholder=""
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="زمان مطالعه"
                            label-for="ReadingTime"
                          >
                            <b-input-group append="دقیقه">
                              <cleave
                                v-model="Form.ReadingTime"
                                class="form-control"
                                :raw="false"
                                :options="options"
                              />
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12">
                          <b-form-group
                            label="تگ ها"
                            label-for="Tag"
                          >
                            <b-form-tags
                              v-model="Form.Tag"
                              name="Tag"
                              placeholder=""
                              add-button-text="افزودن"
                              add-button-variant="outline-primary"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="12">
                          <b-form-group
                            label="پروژه های مرتبط"
                            label-for="ProjectId"
                          >
                            <z-project
                              v-model="Form.ProjectId"
                              :multiple="true"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="12">
                          <b-form-group
                            label="خلاصه"
                            label-for="ShortDescription"
                          >
                            <b-form-textarea
                              id="ShortDescription"
                              v-model="Form.ShortDescription"
                              name="ShortDescription"
                              rows="5"
                              no-resize
                            />
                          </b-form-group>
                        </b-col>

                        <b-col cols="12">
                          <div class="divider divider-solid">
                            <div
                              class="divider-text"
                              style="font-weight: 600;"
                            >
                              ویدئو
                            </div>
                          </div>
                        </b-col>

                        <div>
                          <!--                          &lt;!&ndash; باکس انتخاب فایل &ndash;&gt;-->
                          <!--                          <div @click="openFilePicker" class="file-upload-box">-->
                          <!--                            <span v-if="!selectedFile">برای آپلود فیلم کلیک کنید</span>-->
                          <!--                            <span v-else>فیلم انتخاب شده: {{ selectedFile.name }}</span>-->
                          <!--                          </div>-->

                          <!-- Input مخفی برای انتخاب فایل -->
                          <input
                            ref="fileInput"
                            type="file"
                            style="display: none"
                            accept="video/*"
                            name="Video"
                            @change="handleFileChange"
                          >

                          <div class="px-1 mb-1 mt-1">
                            <div
                              v-if="!Form.Video"
                              class="activity-upload-video"
                              @click="$refs.fileInput.click()"
                            >
                              <div class="activity-upload-video-icon">
                                <feather-icon
                                  size="24"
                                  icon="UploadIcon"
                                />
                              </div>
                            </div>
                            <!-- نمایش فیلم انتخاب شده -->
                            <div
                              v-else
                              class="blog-video-box"
                            >
                              <video
                                controls
                                :src="Form.Video"
                              />
                            </div>

                          </div>

                        </div>

                        <z-seo v-model="Form" />

                      </b-row>
                    </b-tab>

                    <b-tab title="محتوا">
                      <b-row class="mt-2">
                        <b-col md="12">
                          <b-form-group
                            label-for="Description"
                          >
                            <z-quill-editor v-model="Form.Description" />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-tab>
                    <b-tab>
                      <template #title>
                        <span class="d-none d-sm-inline">گالری</span>
                      </template>
                      <b-row>
                        <div
                          v-for="(item, index) in Form.BlogGallery"
                          :key="item.Id"
                          class="px-1 mb-1"
                        >
                          <b-avatar
                            ref="previewEl"
                            :src="item.Url"
                            size="120px"
                            rounded
                            class="foodrecipes-image mt-1"
                          />
                          <b-button
                            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            variant="outline-secondary"
                            style="margin-top: 0.5rem;"
                            class="btn-icon video-remove"
                            @click="removeGallery(item)"
                          >
                            <feather-icon
                              icon="XIcon"
                              size="14"
                            />
                          </b-button>
                        </div>

                        <input
                          ref="refGalley1"
                          type="file"
                          class="d-none is-primary"
                          accept="image/*"
                          @change="galleryRenderer($event)"
                        >

                        <div class="px-1 mb-1 mt-1">
                          <div
                            class="activity-upload-video"
                            @click="$refs.refGalley1.click()"
                          >
                            <div class="activity-upload-video-icon">
                              <feather-icon
                                size="24"
                                icon="UploadIcon"
                              />
                            </div>
                          </div>
                        </div>

                      </b-row>
                    </b-tab>
                    <b-tab title="سوالات متداول">
                      <b-row class="mt-2">
                        <b-col cols="12">
                          <b-row
                            v-for="(item, index) in Form.BlogFaq"
                            :key="index"
                          >

                            <b-col md="10">
                              <b-form-group
                                label="سوال"
                              >
                                <b-form-input
                                  v-model="item.Title"
                                  autocomplete="off"
                                />
                              </b-form-group>
                            </b-col>

                            <b-col
                              md="2"
                              class="mb-1"
                              style="display: flex; align-items: flex-end;"
                            >
                              <template v-if="blogFaqRemoveId !== index">
                                <b-button
                                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                  variant="outline-danger"
                                  class="btn-icon rounded-circle"
                                  @click="removeBlogFaq(index)"
                                >
                                  <feather-icon
                                    icon="TrashIcon"
                                  />
                                </b-button>
                              </template>
                              <template v-else>
                                <b-button
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  class="btn-icon rounded-circle"
                                  variant="outline-primary"
                                  @click="cancelBlogFaq"
                                >
                                  <feather-icon icon="XIcon" />
                                </b-button>
                                <b-button
                                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                  class="btn-icon rounded-circle ml-1"
                                  variant="outline-primary"
                                  @click="confirmBlogFaq"
                                >
                                  <feather-icon icon="CheckIcon" />
                                </b-button>
                              </template>
                            </b-col>

                            <b-col cols="12">
                              <b-form-group
                                label="پاسخ"
                                label-for="Description"
                              >
                                <div class="form-label-group">
                                  <b-form-textarea
                                    id="Description"
                                    v-model="item.Description"
                                    autocomplete="off"
                                    rows="3"
                                    no-resize
                                  />
                                </div>
                              </b-form-group>
                            </b-col>

                            <b-col cols="12">
                              <hr>
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col>
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="gradient-info"
                            @click="addBlogFaq"
                          >
                            <feather-icon
                              icon="PlusIcon"
                              class="mr-25"
                            />
                            <span>افزودن</span>
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-tab>

                  </b-tabs>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col
                    cols="12"
                    class="mt-1 mb-2 text-center"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>

        </b-card>
      </b-col>
    </b-row>

    <!--    <b-modal-->
    <!--        v-model="showModalLinkAttr"-->
    <!--        ok-title="دنبال نشود"-->
    <!--        cancel-title="دنبال بشود"-->
    <!--        cancel-variant="outline-secondary"-->
    <!--        centered-->
    <!--        title="اضافه کردن  attribute به لینک"-->
    <!--        :no-close-on-backdrop="true"-->
    <!--        size="sm"-->
    <!--        @ok="addLinkAttr"-->
    <!--        @cancel="closeLinkAttrModal()"-->
    <!--    >-->
    <!--      <div >-->
    <!--        <p>آیا این  لینک توسط موتور جستجو دنبال بشود یا نشود</p>-->
    <!--      </div>-->
    <!--    </b-modal>-->
  </b-overlay>
</template>

<script>

import ZBlogCategory from '@/tools/blogcategory.vue'
import ZQuillEditor from '@/tools/quilleditor.vue'
import ZSeo from '@/tools/seo.vue'
import ZProject from '@/tools/project.vue'

export default {
  name: 'BlogDetails',
  components: {
    ZProject,
    ZSeo,
    ZQuillEditor,
    ZBlogCategory,
  },
  data() {
    return {
      Schemas: [],
      Form: {
        Id: 0,
        Title: '',
        MetaTitle: '',
        Description: '',
        Image: null,
        Video: null,
        Visibility: true,
        BlogFaq: [],
        BlogCategoryId: null,
        ProjectId: [],
        Tag: [],
        ShortDescription: '',
        ImageAlt: '',
        Canonical: '',
        IndexPost: true,
        Schemas: [],
        Type: 0,
        Url: '',
        Slug: null,
        BlogContentType: 0,
        Sort: 0,
        BlogGallery: [],
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      GalleryFile: [],
      galleryId: 0,
      loading: false,
      showModalLinkAttr: false,
      elementTemp: null,
      blogFaqRemoveId: null,
      selectedFile: null,
      videoUrl: null,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.blog.add
      if (this.$route.params.id) {
        url = this.$api.blog.update
      }

      const formData = new FormData(this.$refs.blogform)

      formData.append('Id', this.Form.Id)
      formData.append('Visibility', this.Form.Visibility)
      formData.append('Type', this.Form.Type)
      formData.append('Description', this.Form.Description)
      formData.append('PublishAt', this.Form.PublishAt)

      if (this.Form.BlogCategoryId) {
        formData.append('BlogCategoryId', this.Form.BlogCategoryId)
      }

      if (this.Form.ReadingTime) {
        formData.append('ReadingTime', this.Form.ReadingTime.replaceAll(',', ''))
      }

      this.Form.BlogGallery.forEach((item, index) => {
        formData.append(`BlogGallery[${index}].Id`, item.Id)
        if (item.Title) {
          formData.append(`BlogGallery[${index}].Title`, item.Title)
        }

        formData.append(`BlogGallery[${index}].Sort`, index)
        if (this.GalleryFile.filter(x => x.Id == item.Id)[0]) {
          formData.append(`BlogGallery[${index}].Url`, this.GalleryFile.filter(x => x.Id == item.Id)[0].Url)
        }
      })

      this.Form.BlogFaq.forEach((item, index) => {
        formData.append(`BlogFaq[${index}].Title`, item.Title)
        formData.append(`BlogFaq[${index}].Description`, item.Description)
      })

      this.Form.ProjectId.forEach((item, index) => {
        formData.append(`ProjectId[${index}]`, item)
      })

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.blog.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          this.Schemas = this.Form.Schemas
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    addLinkAttr() {
      this.elementTemp.target.setAttribute('rel', 'nofollow')
      this.showModalImageAttr = false
    },
    closeLinkAttrModal() {
      this.elementTemp.target.setAttribute('rel', ' ')
    },
    addBlogFaq() {
      this.Form.BlogFaq.push({ Title: null, Description: null })
    },
    removeBlogFaq(index) {
      this.blogFaqRemoveId = index
    },
    confirmBlogFaq() {
      this.Form.BlogFaq.splice(this.blogFaqRemoveId, 1)
      this.blogFaqRemoveId = null
    },
    cancelBlogFaq() {
      this.blogFaqRemoveId = null
    },
    galleryRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.galleryId++
        this.Form.BlogGallery.push({ Url: fileReader.result, Id: this.galleryId })
        this.GalleryFile.push({ Url: event.target.files[0], Id: this.galleryId })
      }
    },
    removeGallery(item) {
      this.Form.BlogGallery = this.Form.BlogGallery.filter(x => x.Id !== item.Id)
    },

    // باز کردن دیالوگ انتخاب فایل
    openFilePicker() {
      this.$refs.fileInput.click()
    },

    // مدیریت تغییر فایل
    handleFileChange(event) {
      const file = event.target.files[0]
      if (file && file.type.startsWith('video/')) {
        this.selectedFile = file
        this.Form.Video = URL.createObjectURL(file) // ایجاد URL برای نمایش فیلم
      } else {
        alert('لطفاً یک فایل ویدیویی انتخاب کنید.')
      }
    },

  },
}
</script>

<style scoped>

[dir=rtl] .input-group-url  {
  direction: ltr;
}

[dir=rtl] .input-group-url .input-group-prepend {
  margin-left: 0 !important;
  margin-right: -1px !important;
}

[dir=rtl] .input-group-url .input-group-text {
  border-top-left-radius: 0.357rem !important;
  border-bottom-left-radius: 0.357rem !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-left: 1px solid #d8d6de;
}

[dir=rtl] .input-group-url .form-control {
  border-top-right-radius: 0.357rem !important;
  border-bottom-right-radius: 0.357rem !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-right: 1px solid #d8d6de !important;
  padding: 0.438rem 1rem !important;
}

[dir=rtl] .input-group-url .form-control:focus-within {
  border-right: 1px solid #7367f0 !important;
}

.media {
  display: flex;
  align-items: flex-end;
}
.blog-video-box{
  line-height: 0px;
  padding: 0.438rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}

.blog-video-box video{
  border-radius: 0.357rem;
  width: 100%;
}
</style>
